(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/trend.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/trend.js');
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  useRef,
  useEffect,
  useReducer
} = React;
const {
  useSelector
} = ReactRedux;
const {
  isTextOrNumber
} = svs.components.tipsen.tipsinfo.utils;
const Trends = {
  UP: 'up',
  DOWN: 'down',
  NEUTRAL: 'neutral'
};
const Actions = {
  NEW_UNIQUE_ID: 'new_unique_id',
  NEW_VALUE: 'new_value'
};
const TrendChangeTimeout = 7 * 1000;
const trendReducer = (state, action) => {
  switch (action.type) {
    case Actions.NEW_UNIQUE_ID:
    case Actions.NEW_VALUE:
      return _objectSpread(_objectSpread({}, state), action.payload);
    default:
      return state;
  }
};
const Trend = _ref => {
  let {
    uniqueId,
    postfixSymbol,
    selectorFunction
  } = _ref;
  const timer = useRef();
  const value = useSelector(selectorFunction);
  const [state, dispatch] = useReducer(trendReducer, {
    uniqueId,
    value
  });
  useEffect(() => {
    const resetLastStatValue = () => {
      dispatch({
        type: Actions.NEW_VALUE,
        payload: {
          value
        }
      });
    };
    timer.current = setTimeout(resetLastStatValue, TrendChangeTimeout);
    return () => {
      clearTimeout(timer.current);
      resetLastStatValue();
    };
  }, [value]);
  useEffect(() => {
    if (state.uniqueId !== uniqueId) {
      dispatch({
        type: Actions.NEW_UNIQUE_ID,
        payload: {
          uniqueId,
          value
        }
      });
      clearTimeout(timer.current);
    }
  }, [uniqueId, value, state.uniqueId]);
  let trend = Trends.NEUTRAL;
  if (uniqueId === state.uniqueId) {
    if (value > state.value) {
      trend = Trends.UP;
    } else if (value < state.value) {
      trend = Trends.DOWN;
    }
  }
  const presentableValue = isTextOrNumber(value) ? "".concat(value).concat(postfixSymbol !== null && postfixSymbol !== void 0 ? postfixSymbol : '') : '-';
  return React.createElement("div", {
    className: "stat-trend stat-trend-".concat(trend)
  }, presentableValue);
};
setGlobal('svs.components.tipsen.tipsinfo.Trend', Trend);

 })(window);